import { useEffect, useState } from 'react';
import axios from "axios";

let EXITSCREEN_POSTS: any[] = [];

const useExitScreenPosts = () => {

    const [exitScreenPosts, setExitScreenPosts] = useState<any[]>(EXITSCREEN_POSTS);

    useEffect(() => {
        if (EXITSCREEN_POSTS.length > 0)
            return;

        (async () => {
            let posts = [];
            try {
                const { data } = await axios.get(`${window.API_HOST}/api/posts?type=exit-screen&page=1`);
                posts = data?.posts ?? [];
            } catch { }

            EXITSCREEN_POSTS = posts;
            setExitScreenPosts(posts);
        })();
    }, []);

    return exitScreenPosts;
};

export default useExitScreenPosts;